import React, { useEffect, useState } from 'react'
import { injectIntl } from 'react-intl'
import Masonry from 'react-masonry-css'
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/thumbnails.css'
import Lightbox from 'yet-another-react-lightbox'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'

import { Box } from '@material-ui/core'

import { useGalleryImageFormatting } from 'hooks/useGalleryImageFormatting'
import { useStyles } from './ShowPageImages_style'
import GallerySlide from './components/GallerySlide'
import GalleryImage from './components/GalleryImage'

const ShowPageImages = (props) => {
    const classes = useStyles()
    const { images, onLoad, limit, companyName } = props
    const [currentImage, setCurrentImage] = useState(0)
    const [lightboxOpen, setSetLightboxOpen] = useState(false)
    const [mediaItems, setMediaItems] = useState([])
    const { formatMessage } = props.intl
    const breakpointColumns = {
        default: 2,
        700: 1
    }

    useEffect(() => {
        let limitedImages = images
        if (limit) {
            limitedImages = limitedImages.slice(0, limit)
        }
        const formattedImages = useGalleryImageFormatting(limitedImages, onLoad, companyName, formatMessage)
        setMediaItems(formattedImages)
    }, [images])

    const openLightbox = (index) => {
        setSetLightboxOpen(true)
        setCurrentImage(index)
    }

    const closeLightbox = () => {
        setSetLightboxOpen(false)
        setCurrentImage(0)
    }

    const renderSlide = (mediaItem) => <GallerySlide mediaItem={mediaItem} />

    return (
        <Box>
            {mediaItems.length > 0 &&
                <Box className={classes.imagesGallery}>
                    <Masonry breakpointCols={mediaItems.length === 1 ? 1 : breakpointColumns} className={classes.masonryGrid} columnClassName={classes.masonryGridColumns}>
                        {mediaItems.map((photo, index) => (
                            <GalleryImage
                                image={photo}
                                key={photo.cloudinary_key}
                                index={index}
                                openLightbox={openLightbox}
                            />
                        ))}
                    </Masonry>
                    <Lightbox
                        open={lightboxOpen}
                        close={closeLightbox}
                        slides={mediaItems}
                        plugins={[Thumbnails, Zoom]}
                        render={{ slide: ({ slide }) => renderSlide(slide) }}
                        index={currentImage}
                    />
                </Box>
            }
        </Box>
    )
}
export default injectIntl(ShowPageImages)
